import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type CustomersQueryVariables = Types.Exact<{
  filters: Types.CustomersListFilterInput
  pagination?: Types.InputMaybe<Types.PaginationInput>
  sorts?: Types.InputMaybe<Types.CustomersListSortInput>
}>

export type CustomersQuery = {
  __typename?: 'Query'
  customers: {
    __typename?: 'CustomersCollection'
    skip?: number | null
    total: number
    items: Array<{
      __typename?: 'Customer'
      id: number
      firstName?: string | null
      lastName?: string | null
      membership?: {
        __typename?: 'Membership'
        uuid: string
        membershipNumber: string
        product: { __typename?: 'Product'; id: number; name: string }
        membershipType: { __typename?: 'MembershipType'; uid: string; displayName: string }
      } | null
      currentSingleProductPurchase?: {
        __typename?: 'Purchase'
        product?: { __typename?: 'Product'; id: number; name: string } | null
      } | null
    }>
  }
}

export const CustomersDocument = gql`
  query Customers(
    $filters: CustomersListFilterInput!
    $pagination: PaginationInput
    $sorts: CustomersListSortInput
  ) {
    customers(filters: $filters, pagination: $pagination, sorts: $sorts) {
      items {
        id
        firstName
        lastName
        membership {
          uuid
          membershipNumber
          product {
            id
            name
          }
          membershipType {
            uid
            displayName
          }
        }
        currentSingleProductPurchase {
          product {
            id
            name
          }
        }
      }
      skip
      total
    }
  }
`
export function useCustomersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<CustomersQuery, CustomersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CustomersQuery, CustomersQueryVariables>(
    CustomersDocument,
    options
  )
}
export function useCustomersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomersQuery, CustomersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CustomersQuery, CustomersQueryVariables>(
    CustomersDocument,
    options
  )
}
export type CustomersQueryHookResult = ReturnType<typeof useCustomersQuery>
export type CustomersLazyQueryHookResult = ReturnType<typeof useCustomersLazyQuery>
export type CustomersQueryResult = ApolloReactCommon.QueryResult<
  CustomersQuery,
  CustomersQueryVariables
>
export function refetchCustomersQuery(variables?: CustomersQueryVariables) {
  return { query: CustomersDocument, variables: variables }
}
